import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType, ogImage, schema }: SEOHeadProps) {
  const location = useLocation();
  const currentUrl = typeof window !== 'undefined' ? window.location.origin + location.pathname : '';

  useEffect(() => {
    const baseTitle = '黑料曝光 - 真实内幕全收录';
    const finalTitle = title ? `${title} - 黑料曝光` : baseTitle;
    document.title = finalTitle;

    const updateMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const finalDesc = description || '黑料曝光专题页，汇聚最新、最全的真实内幕信息。无论是娱乐圈、商业圈还是网红博主，这里第一时间呈现经过核实的黑料曝光内容，助你看清真相、辨别是非，拒绝虚假信息。';
    const finalKw = keywords || '黑料曝光,明星黑料曝光,网红黑料曝光,最新黑料曝光,娱乐圈内幕曝光,黑料曝光合集,真实黑料曝光事件';
    const finalCanonical = canonicalUrl || currentUrl;

    updateMeta('description', finalDesc);
    updateMeta('keywords', finalKw);
    updateMeta('og:title', finalTitle, true);
    updateMeta('og:description', finalDesc, true);
    updateMeta('og:type', ogType || 'website', true);
    updateMeta('og:url', finalCanonical, true);
    updateMeta('og:image', ogImage || 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20journalism%20themed%20banner%20with%20breaking%20news%20vibe%2C%20warm%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20style&width=1200&height=630&seq=og-default&orientation=landscape', true);
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', finalTitle);
    updateMeta('twitter:description', finalDesc);
    updateMeta('twitter:image', ogImage || 'https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20journalism%20themed%20banner%20with%20breaking%20news%20vibe%2C%20warm%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20style&width=1200&height=630&seq=og-default&orientation=landscape');

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', finalCanonical);

    if (schema) {
      const schemas = Array.isArray(schema) ? schema : [schema];
      document.querySelectorAll('script[type="application/ld+json"]').forEach((el) => el.remove());
      schemas.forEach((s) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(s);
        document.head.appendChild(script);
      });
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, schema, currentUrl]);

  return null;
}